'use strict';

import Highstock from 'highcharts/highstock';
import { isNumber } from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
import HC_exportData from 'highcharts/modules/export-data';
HC_exporting(Highstock);
HC_exportData(Highstock);

/**
 *
 * @param data Highcharts formatted 2 dimensional array (timestamp and value)
 * @param base Initial base, typically this is 100 but sometimes might be 0
 * @returns {*[]}
 */
let rebase = (data, base) => {
  let rebased = [[data[0][0], base]]; // 0th item is the base price

  for ( let i=1; i < data.length; i++ ) {
    rebased[i] = [
      data[i][0], // Timestamp remains unchanged
      (100/data[0][1])*data[i][1] - (100-base),
    ];
  }

  return rebased;
};

export default {
  /**
   * Initialise
   */
  init() {
    $('.table-from-sheets').each(function() {
      const $self = $(this);
      $.getJSON(
        'https://02mvmo72z4.execute-api.eu-west-2.amazonaws.com/prod/sheet/' +
          $self.data('id'),
        {
          sheet: $self.data('tab'),
          range: $self.data('range'),
          headers: $self.data('headers'),
        }
      )
        .done(function(data) {
          for (let i = 0; i < data.cols.length; i++) {
            if (data.cols[i].label) {
              $self.find(`th[data-idx='${i}']`).html(data.cols[i].label);
            } else {
              $self.find(`th[data-idx='${i}']`).html('');
            }
          }
          for (let i = 0; i < data.rows.length; i++) {
            for (let j = 0; j < data.rows[i].length; j++) {
              let val = data.rows[i][j];

              // Fix unicode issues
              val = val.replace(/u([\da-f]{4})/g, (_, v) =>
                String.fromCharCode(parseInt(v, 16))
              );

              // Parse URLs into <a href>
              val = val.replace(/(https?:\/\/.+)/g, (_, v) => {
                let title = $self.data('url-label') || v;
                return `<a class="icon-file" href="${v}" target="_blank">${title}</a>`;
              });

              $self.find(`[data-idx='${i}.${j}']`).html(val);
            }
          }
        })
        .fail(function() {
          console.error('failed connection');
        });
    });

    $('.field-from-sheets').each(function() {
      const $self = $(this);
      $.getJSON(
        'https://02mvmo72z4.execute-api.eu-west-2.amazonaws.com/prod/sheet/' +
          $self.data('id'),
        { sheet: $self.data('tab'), range: $self.data('range') }
      )
        .done(function(data) {
          let val = data.rows[0][0];

          // Fix unicode issues
          val = val.replace(/u([\da-fA-F]{4})/g, (_, v) =>
            String.fromCharCode(parseInt(v, 16))
          );

          $self.text(val);
        })
        .fail(function() {
          console.error('failed connection');
        });
    });

    $('.files-from-sheets').each(function() {
      const $self = $(this);
      const filenameTemplate = $self.data('template');
      $.getJSON(
        'https://02mvmo72z4.execute-api.eu-west-2.amazonaws.com/prod/sheet/' +
          $(this).data('id'),
        { sheet: $(this).data('tab'), range: $(this).data('range') }
      )
        .done(function(data) {
          for (let i = 0; i < data.rows.length; i++) {
            let $li = $self.find(`[data-idx='${i}']`);
            let $a = $li.find('a');
            let href = '',
              filename = filenameTemplate;

            // We don't know what order the columns will be in, so scan them for a url and build up the filename
            for (let j = 0; j < data.rows[i].length; j++) {
              filename = filename.replace(
                new RegExp(`\\{${j + 1}\\}`),
                data.rows[i][j]
              );
              if (data.rows[i][j].match(/^http/)) {
                href = data.rows[i][j];
              }
            }

            // If there was no URL at all, remove this item and skip
            if (href === '') {
              $li.remove();
              continue;
            }

            // Populate the DOM
            $a.html(filename).attr('href', href);
          }
        })
        .fail(function() {
          console.error('failed connection');
        });
    });

    const primaryColor = '#2C626C'; //primary
    const secondaryColor = '#3F99B1'; //secondary
    const tertiaryColor = '#2C426C'; //blue dark
    const fontColor = '#000000'; //black
    const fontSize = '16px';
    const fontFamily = 'Rubik, sans-serif';

    // Apply the theme
    Highstock.setOptions({
      colors: [primaryColor, secondaryColor],
      credits: {
        enabled: false,
      },
      chart: {
        backgroundColor: '#FFFFFF',
        plotBackgroundColor: '#FFFFFF',
        height: 600,
      },
      xAxis: {
        lineColor: fontColor,
        tickColor: fontColor,
        labels: {
          style: {
            color: fontColor,
          },
        },
        title: {
          style: {
            color: fontColor,
            fontSize: fontSize,
            fontFamily: fontFamily,
          },
        },
      },
      yAxis: {
        backgroundColor: '#F9F7F1',
        lineColor: fontColor,
        tickColor: fontColor,
        labels: {
          style: {
            color: fontColor,
          },
        },
        title: {
          style: {
            color: fontColor,
            fontSize: fontSize,
            fontFamily: fontFamily,
            fontWeight: 'bold',
          },
        },
      },
      navigator: {
        enabled: false,
      },
      rangeSelector: {
        enabled: false,
      },
      scrollbar: {
        barBackgroundColor: '#E2E5E6',
        buttonArrowColor: '#000000',
        buttonBackgroundColor: '#DDDAD2',
        rifleColor: '#FFFFFF',
        trackBackgroundColor: '#DDDAD2',
      },
    });

    $('.chart-from-sheets.chart-type-line_series').each(function() {
      const colors = $(this).data('colors');
      const chart = Highstock.stockChart(this, {
        colors,
        title: {
          text: '',
          align: 'left',
          style: {
            color: fontColor,
          },
        },
        xAxis: {
          type: 'datetime',
        },
        yAxis: [
          {
            title: {
              text: 'Price (% change)',
            },
            opposite: false,
          },
        ],
        tooltip: {
          valueDecimals: 2,
        },
      });
      chart.showLoading();

      const id = $(this).data('id'),
        sheet = $(this).data('tab'),
        pages = $(this).data('pages'),
        range = $(this).data('range'),
        mode = $(this).data('mode');
      const promises = [];
      const url = `https://02mvmo72z4.execute-api.eu-west-2.amazonaws.com/prod/sheet/${id}`;

      if (typeof pages !== 'undefined' && isNumber(pages)) {
        for (let i = 0; i <= pages; i++) {
          let data = {
            sheet: sheet,
          };

          if (range.match(/[A-Z]{1,2}[0-9]*:[A-Z]{1,2}[0-9]*/g)) {
            // Range used, eg A1:D
            data['range'] = range;
          } else {
            data['tq'] = `${range} limit 1000 offset ${i * 1000}`;
          }
          promises.push($.getJSON(url, data));
        }
      } else {
        promises.push($.getJSON(url, { sheet: sheet, range: range }));
      }

      Promise.all(promises).then(dataArr => {
        let data = {};
        data.cols = dataArr[0].cols;
        data.rows = [];
        for (let i = 0; i < dataArr.length; i++) {
          data.rows = data.rows.concat(dataArr[i].rows);
        }

        let i = 0,
          len = data.rows.length,
          values = [],
          benchmark = [];

        // Loop over the raw data from sheets, parse values and populate values[] and benchmark[]
        while (i < len) {
          values.push([parseInt(data.rows[i][0]), parseFloat(data.rows[i][1])]);
          if (data.cols[2]) {
            benchmark.push([
              parseInt(data.rows[i][0]),
              parseFloat(data.rows[i][2]),
            ]);
          }
          i++;
        }

        // Before we pass the data into highcharts, check if the mode=rebased flag is set, and if so rebase accordingly
        if ( mode === 'rebased' ) {
          values = rebase(values, 0);
          benchmark = rebase(benchmark, 0);
        }

        chart.addSeries({
          yAxis: 0,
          type: 'line',
          name: data.cols[1].label,
          data: values,
        });
        if (data.cols[2]) {
          chart.addSeries({
            yAxis: 0,
            type: 'line',
            name: data.cols[2].label,
            data: benchmark,
          });
        }
        chart.hideLoading();
      });

      if ($(this).data('svg-only')) {
        chart.update({
          navigator: {
            enabled: false,
          },
          scrollbar: {
            enabled: false,
          },
          credits: {
            enabled: false,
          },
          rangeSelector: {
            enabled: false,
          },
          exporting: {
            sourceWidth: 800,
            sourceHeight: 400,
          },
        });
      }

      /*console.log(chart);
      console.log(JSON.stringify(Highstock.charts[0].options));

      document.getElementById('view-data').addEventListener('click', function () {
        console.log(chart.getCSV());
        document.getElementById('print-data').innerHTML = chart.getCSV();
      });
      document.getElementById('print-data').innerHTML = chart.getCSV();*/
    });

    $(
      '.chart-from-sheets.chart-type-donut, .chart-from-sheets.chart-type-donut_notable'
    ).each(function() {
      const $this = $(this); // Performance improvement
      const centerLabel = $this.data('center-label') == '1';
      const colors = $this.data('colors');
      const chart = Highstock.chart(this, {
        chart: {
          type: 'pie',
        },
        title: {
          text: '',
          align: 'center',
          verticalAlign: 'middle',
          style: {
            color: fontColor,
          },
        },
        plotOptions: {
          pie: {
            shadow: false,
            center: ['50%', '50%'],
            dataLabels: {
              enabled: false,
            },
          },
        },
        credits: {
          enabled: false,
        },
      });
      chart.showLoading();

      $.getJSON(
        'https://02mvmo72z4.execute-api.eu-west-2.amazonaws.com/prod/sheet/' +
          $this.data('id'),
        { sheet: $this.data('tab'), range: $this.data('range') }
      )
        .done(function(data) {
          let i = 0,
            len = data.rows.length,
            values = [];
          while (i < len) {
            if (centerLabel && i === 0) {
              chart.setTitle({ text: parseInt(data.rows[i][1]) + '%' });
            }
            values.push({
              name: data.rows[i][0],
              y: parseInt(data.rows[i][1]),
              color: colors[i],
            });
            i++;
          }
          chart.addSeries({
            // size: '80%',
            innerSize: '80%',
            name: data.cols[1].label,
            data: values,
          });

          // Table hover handler
          if ($this.data('type') === 'donut') {
            $(`table.sheet-hash-${$this.data('hash')} tr`)
              .not(':first')
              .on('mouseenter mouseleave', e => {
                const idx = `${$(e.target).data('idx')}`.match(
                  /^([0-9]+)\./
                )[1];
                switch (e.type) {
                  case 'mouseenter':
                    chart.series[0].data[idx].setState('hover');
                    chart.tooltip.refresh(chart.series[0].data[idx]);
                    break;
                  case 'mouseleave':
                    chart.series[0].data[idx].setState();
                    chart.tooltip.hide();
                    break;
                }
              });
          }

          chart.hideLoading();
        })
        .fail(function() {
          console.error('failed connection');
        });
    });

    $(
      '.chart-from-sheets.chart-type-pie'
    ).each(function() {
      const $this = $(this); // Performance improvement
      const centerLabel = $this.data('center-label') == '1';
      const colors = $this.data('colors');
      const chart = Highstock.chart(this, {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
        },
        title: {
          text: '',
          align: 'center',
          verticalAlign: 'middle',
          style: {
            color: fontColor,
          },
        },
        // this will hide label from outer
        plotOptions: {
          pie: {
            shadow: false,
            center: ['50%', '50%'],
            dataLabels: {
              enabled: false,
            },
          },
        },
        credits: {
          enabled: false,
        },
      });
      chart.showLoading();

      $.getJSON(
        'https://02mvmo72z4.execute-api.eu-west-2.amazonaws.com/prod/sheet/' +
          $this.data('id'),
        { sheet: $this.data('tab'), range: $this.data('range') }
      )
        .done(function(data) {
          let i = 0,
            len = data.rows.length,
            values = [];
          while (i < len) {
            if (centerLabel && i === 0) {
              chart.setTitle({ text: parseInt(data.rows[i][1]) + '%' });
            }
            values.push({
              name: data.rows[i][0],
              y: parseInt(data.rows[i][1]),
              color: colors[i],
            });
            i++;
          }

          chart.addSeries({
            name: data.cols[1].label,
            data: values,
          });

          chart.hideLoading();
        })
        .fail(function() {
          console.error('failed connection');
        });
    });

    $(
      '.chart-from-sheets.chart-type-bar'
    ).each(function() {
      const $this = $(this); // Performance improvement
      const centerLabel = $this.data('center-label') == '1';
      const colors = $this.data('colors');
      const chart = Highstock.chart(this, {
        chart: {
          type: 'bar',
        },
        title: {
          text: '',
          align: 'center',
          verticalAlign: 'middle',
          style: {
            color: fontColor,
          },
        },
        // xAxis: {
        //   categories: ['2020/21', '2019/20', '2018/19', '2017/18', '2016/17']
        // },
        yAxis: {
          min: 0,
          title: {
            text: '',
          },
        },
        legend: {
          reversed: true,
        },
        plotOptions: {
          series: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
            },
          },
        },
        credits: {
          enabled: false,
        },
      });
      chart.showLoading();

      $.getJSON(
        'https://02mvmo72z4.execute-api.eu-west-2.amazonaws.com/prod/sheet/' +
          $this.data('id'),
        { sheet: $this.data('tab'), range: $this.data('range') }
      )
        .done(function(data) {
          let i = 0,
            len = data.rows.length,
            values = [],
            firstArray = data.rows[0][1];
          while (i < len) {
            if (centerLabel && i === 0) {
              chart.setTitle({ text: parseInt(data.rows[i][1]) + '%' });
            }
            values.push({
              name: data.rows[i][0],
              data: data.rows[i][1].split(",").map(Number),
            });
            // console.log(data.rows);
            i++;
          }
          
          chart.xAxis[0].setCategories(firstArray.split(","));
          
          values.splice(1).forEach((element, index) => {
            chart.addSeries({
              name: element.name,
              data: element.data,
              color: colors[index],
            });
            // console.log(index);
            // console.log(element);
          })
          
          chart.hideLoading();
        })
        .fail(function() {
          console.error('failed connection');
        });
    });
  },
};
